import { render } from "./App.vue?vue&type=template&id=576a1f76"
const script = {}

import "./App.vue?vue&type=style&index=0&id=576a1f76&lang=css"

import exportComponent from "D:\\CODE\\clpgaAppDevnew\\clpga_html\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__